module.exports = __webpack_public_path__ + "img/rst.cc9efe72.jpg";